/**
 * Enum Array for the roles
 * @readonly
 * @enum {string}
 */
export const ROLES = {
  ADMINISTRATOR: 'ADMINISTRATOR',
  SUPER_USER: 'SUPER USER',
  USER: 'USER',
};

/**
 * Enum for React Query cache keys
 * @readonly
 * @enum {string}
 */
export const QUERY_KEYS = {
  TEAM_MEMBER_APP_PREFERENCES: 'teamMemberAppPreferences',
  TEAM_MEMBER_DATA: 'teamMemberData',
  SITES: 'sites',
  SITE_INFO: 'siteInfo',
  INV_MGMT_COST_CENTER: 'invMgmtCostCenter',
  INV_MGMT_DIV_LOCATIONS: 'invMgmtDivLocations',
  INV_MGMT_DIVISIONS: 'invMgmtDivisions',
  INV_MGMT_LOCATIONS: 'invMgmtLocations',
  INV_MGMT_COST_CENTERS: 'invMgmtCostCenters',
  INV_MGMT_ACCOUNTS: 'invMgmtAccounts',
  INV_MGMT_SEGMENTS: 'invMgmtSegments',
  INV_MGMT_INTERCOMPS: 'invMgmtIntercomps',
  INV_MGMT_ORG_ITEMS: 'invMgmtOrgItems',
  INV_MGMT_ORG_ITEM_DETAIL: 'invMgmtOrgItemDetail',
  INV_MGMT_INV_LOCATIONS: 'invMgmtInvLocations',
  THRIVE_SPARE_PARTS: 'thriveSpareParts',
  THRIVE_PROJECTS: 'thriveProjects',
  THRIVE_EQUIPMENT: 'thriveEquipment',
  THRIVE_EMPLOYEE_USER_DEFAULTS: 'thriveEmployeeUserDefaults',
  THRIVE_EMPLOYEE_USER_STATUS: 'thriveEmployeeUserStatus',
  THRIVE_EQUIPMENT_BY_NUMBER: 'thriveEquipmentByNumber',
  MOVE_ORDER_DIST_ACCT_BY_CC: 'moveOrderDistAcctByCC',
  INV_MGMT_MRO_ORGANIZATIONS: 'invMgmtMROOrganizations',
  INV_MGMT_SUB_INVENTORIES: 'invMgmtSubInventories',
  MAINTENANCE_FOLLOW_UP_QUESTIONS: 'maintenanceFollowUpQuestions',
  USER_ANALYTICS_ROWS: 'userAnalyticsRows',
  USER_ANALYTICS_ROWS_COUNT: 'userAnalyticsRowsCount',
  USER_ANALYTICS_FILTER_OPTIONS: 'userAnalyticsFilterOptions',
  USER_ANALYTICS_ENGAGEMENT_SUMMARY: 'userAnalyticsEngagementSummary',
};
